(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    static observedAttributes = ['aria-hidden'];

    constructor() {
      super();
      this.storageKey = this.dataset.storageKey || 'announcement-closed';
      this.ariaHidden = window.sessionStorage.getItem(this.storageKey) !== null;
    }

    connectedCallback() {
      this.querySelectorAll('[data-close]').forEach((closeElement) => {
        closeElement.addEventListener('click', () => {
          const cssRoot = document.querySelector(':root');
          cssRoot.style.setProperty('--announcement-bar-height', '0px');
          closeElement.blur(); // For accessibility
          this.ariaHidden = true;

          const customEvent = new CustomEvent('announcementClosed', {
            detail: { message: 'Announcement bar closed' },
          });

          // Dispatch the custom event
          closeElement.dispatchEvent(customEvent);
        });
      });
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'aria-hidden') {
        try {
          if (newValue === 'true') {
            window.sessionStorage.setItem(this.storageKey, true);
          } else {
            window.sessionStorage.removeItem(this.storageKey);
          }
        } catch (error) {
          window.console.warn(error);
        }
      }
    }
  }
  window.customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-strip"]) return;
  try {
    
  const normalizeGeoTargetValue = (value = '') => value.toString().trim().toUpperCase();
  const normalizeGeoTargetPostalCode = (value = '') => normalizeGeoTargetValue(value).replace(/[^A-Z0-9]/g, '');

  const parseGeoTargetValueList = (value = '') =>
    value
      .split(/\r?\n|,/)
      .map((entry) => normalizeGeoTargetValue(entry))
      .filter(Boolean);

  const parseGeoTargetPostalValueList = (value = '') =>
    value
      .split(/\r?\n|,/)
      .map((entry) => normalizeGeoTargetPostalCode(entry).slice(0, 3))
      .filter(Boolean);

  const buildPromoStripGeoCandidates = (geo = {}) => {
    const countryCode = normalizeGeoTargetValue(geo.countryCode);
    const countryName = normalizeGeoTargetValue(geo.countryName);
    const regionCode = normalizeGeoTargetValue(geo.regionCode);
    const regionName = normalizeGeoTargetValue(geo.regionName);

    const candidates = new Set([countryCode, countryName, regionCode, regionName].filter(Boolean));

    if (countryCode && regionCode) {
      candidates.add(`${countryCode}-${regionCode}`);
    }

    if (countryCode && regionName) {
      candidates.add(`${countryCode}-${regionName}`);
    }

    if (countryName && regionCode) {
      candidates.add(`${countryName}-${regionCode}`);
    }

    if (countryName && regionName) {
      candidates.add(`${countryName}-${regionName}`);
    }

    return candidates;
  };

  const slideHasGeoTarget = (slide) =>
    Boolean(
      slide.dataset.geoTargetRegionValues || slide.dataset.geoTargetCityValues || slide.dataset.geoTargetPostalPrefixes
    );

  const matchesPromoStripGeo = (slide, geo) => {
    const regionValues = parseGeoTargetValueList(slide.dataset.geoTargetRegionValues || '');
    const cityValues = parseGeoTargetValueList(slide.dataset.geoTargetCityValues || '');
    const postalPrefixes = parseGeoTargetPostalValueList(slide.dataset.geoTargetPostalPrefixes || '');

    if (!regionValues.length && !cityValues.length && !postalPrefixes.length) {
      return false;
    }

    const geoCandidates = buildPromoStripGeoCandidates(geo);

    if (!geoCandidates.size) {
      return false;
    }

    if (regionValues.length) {
      const hasRegionMatch = regionValues.some((entry) => geoCandidates.has(entry));

      if (!hasRegionMatch) {
        return false;
      }
    }

    if (cityValues.length) {
      const cityCandidate = normalizeGeoTargetValue(geo.city);

      if (!cityCandidate || !cityValues.includes(cityCandidate)) {
        return false;
      }
    }

    if (postalPrefixes.length) {
      const fsaCandidate = normalizeGeoTargetPostalCode(geo.fsa || geo.postalCode).slice(0, 3);

      if (!fsaCandidate || !postalPrefixes.includes(fsaCandidate)) {
        return false;
      }
    }

    return true;
  };

  class PromoStripSection extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.intervalId = null;
      this.headerElem = null;
      this.geoVisibleSlides = [];
      this.selectedSlide = null;
      this.stickyOffsetFrame = null;
      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleAnnouncementClosed = this.handleAnnouncementClosed.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handleVisitorGeoInitialized = this.handleVisitorGeoInitialized.bind(this);
      this.handleVisitorGeoReady = this.handleVisitorGeoReady.bind(this);
    }

    connectedCallback() {
      this.layout = this.dataset.layout;
      this.timerLength = Number(this.dataset.timerLength || 9) * 1000;
      this.stickyEnabled = this.dataset.sticky === 'true';
      this.headerElem = document.querySelector('[data-header]') || document.querySelector('header');
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.loadingStrategy = this.dataset.geoTargetLoadingStrategy || 'show_default';
      this.previousControl = this.querySelector('[data-direction="previous"]');
      this.nextControl = this.querySelector('[data-direction="next"]');

      if (this.previousControl) {
        this.previousControl.addEventListener('click', () => this.goToPreviousSlide());
      }

      if (this.nextControl) {
        this.nextControl.addEventListener('click', () => this.goToNextSlide());
      }

      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

      this.renderInitialGeoState();
      this.refresh();
      this.resolveGeoTarget();

      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('announcementClosed', this.handleAnnouncementClosed, true);
      document.addEventListener('theme:visitor-geo:initialized', this.handleVisitorGeoInitialized);
      document.addEventListener('theme:visitor-geo:ready', this.handleVisitorGeoReady);
    }

    disconnectedCallback() {
      this.stopTimer();
      if (this.stickyOffsetFrame) {
        window.cancelAnimationFrame(this.stickyOffsetFrame);
        this.stickyOffsetFrame = null;
      }
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('announcementClosed', this.handleAnnouncementClosed, true);
      document.removeEventListener('theme:visitor-geo:initialized', this.handleVisitorGeoInitialized);
      document.removeEventListener('theme:visitor-geo:ready', this.handleVisitorGeoReady);
    }

    get isDesktop() {
      return this.desktopMediaQuery.matches;
    }

    get visibleSlides() {
      if (this.selectedSlide) {
        return [this.selectedSlide];
      }

      return this.slides.filter((slide) => {
        const isGeoVisible = this.geoVisibleSlides.includes(slide);
        if (!isGeoVisible) return false;

        const devices = slide.dataset.devices || 'all';
        if (devices === 'all') return true;
        if (devices === 'desktop') return this.isDesktop;
        if (devices === 'mobile') return !this.isDesktop;
        return true;
      });
    }

    get defaultSlides() {
      return this.slides.filter((slide) => !slideHasGeoTarget(slide));
    }

    get targetedSlides() {
      return this.slides.filter((slide) => slideHasGeoTarget(slide));
    }

    getPreviewGeo() {
      if (!window.Shopify?.designMode) {
        return null;
      }

      const previewRegion = this.dataset.geoTargetPreviewRegion || '';
      const previewCity = this.dataset.geoTargetPreviewCity || '';
      const previewFsa = normalizeGeoTargetPostalCode(this.dataset.geoTargetPreviewFsa || '').slice(0, 3);

      if (!previewRegion && !previewCity && !previewFsa) {
        return null;
      }

      return {
        countryCode: 'CA',
        regionCode: previewRegion,
        regionName: previewRegion,
        city: previewCity,
        fsa: previewFsa,
        postalCode: previewFsa,
      };
    }

    handleBlockSelect(event) {
      const selectedSlide = event.target.closest('[data-slide]');

      if (!selectedSlide || !this.contains(selectedSlide)) {
        return;
      }

      this.selectedSlide = selectedSlide;
      this.refresh();
    }

    handleBlockDeselect() {
      this.selectedSlide = null;
      this.refresh();
    }

    handleResize() {
      this.refresh();
    }

    handleScroll() {
      if (!this.stickyEnabled) return;
      this.scheduleStickyOffsetUpdate();
    }

    handleAnnouncementClosed() {
      if (!this.stickyEnabled) return;
      this.scheduleStickyOffsetUpdate();
    }

    handleVisitorGeoInitialized() {
      this.resolveGeoTarget();
    }

    handleVisitorGeoReady(event) {
      if (!event.detail || !this.targetedSlides.length) {
        return;
      }

      this.applyGeo(event.detail);
    }

    setGeoVisibleSlides(slides) {
      this.geoVisibleSlides = slides;
    }

    applyDefaultGeoState() {
      this.setGeoVisibleSlides(this.defaultSlides);
      this.refresh();
    }

    getResolvedSlides(matchedSlides = []) {
      if (!matchedSlides.length) {
        return this.defaultSlides;
      }

      return this.slides.filter((slide) => this.defaultSlides.includes(slide) || matchedSlides.includes(slide));
    }

    renderInitialGeoState() {
      if (!this.targetedSlides.length) {
        this.setGeoVisibleSlides(this.slides);
        return;
      }

      if (this.loadingStrategy === 'hide_until_resolved') {
        this.setGeoVisibleSlides([]);
        return;
      }

      this.setGeoVisibleSlides(this.defaultSlides);
    }

    applyGeo(geo) {
      const matchedSlides = this.targetedSlides.filter((slide) => matchesPromoStripGeo(slide, geo));

      this.setGeoVisibleSlides(this.getResolvedSlides(matchedSlides));

      this.refresh();
    }

    async resolveGeoTarget() {
      if (!this.targetedSlides.length) {
        return;
      }

      const previewGeo = this.getPreviewGeo();

      if (previewGeo) {
        this.applyGeo(previewGeo);
        return;
      }

      const visitorGeo = window.theme?.visitorGeo;

      if (!visitorGeo?.get || !visitorGeo?.getSync) {
        this.applyDefaultGeoState();
        return;
      }

      const cachedGeo = visitorGeo.getSync();

      if (cachedGeo) {
        this.applyGeo(cachedGeo);
        return;
      }

      const resolvedGeo = await visitorGeo.get();

      if (resolvedGeo) {
        this.applyGeo(resolvedGeo);
        return;
      }

      this.applyDefaultGeoState();
    }

    scheduleStickyOffsetUpdate() {
      if (this.stickyOffsetFrame) return;

      this.stickyOffsetFrame = window.requestAnimationFrame(() => {
        this.stickyOffsetFrame = null;
        this.updateStickyOffset();
      });
    }

    refresh() {
      const visibleSlides = this.visibleSlides;

      this.hidden = visibleSlides.length === 0;

      this.updateSlideVisibility(visibleSlides);
      this.updateStickyOffset();

      if (this.layout === 'inline') {
        this.stopTimer();
        return;
      }

      if (visibleSlides.length === 0) {
        this.stopTimer();
        return;
      }

      if (this.currentSlide >= visibleSlides.length) {
        this.currentSlide = 0;
      }

      this.renderActiveSlide(visibleSlides);

      if (this.layout === 'alternate_timer') {
        this.startTimer(visibleSlides);
      } else {
        this.stopTimer();
      }
    }

    updateSlideVisibility(visibleSlides = this.visibleSlides) {
      this.slides.forEach((slide) => {
        const isVisible = this.selectedSlide ? slide === this.selectedSlide : visibleSlides.includes(slide);
        slide.hidden = !isVisible;
        slide.classList.remove('is-active');
      });

      const controlsHidden = visibleSlides.length <= 1;
      if (this.previousControl) this.previousControl.hidden = controlsHidden;
      if (this.nextControl) this.nextControl.hidden = controlsHidden;
    }

    renderActiveSlide(visibleSlides = this.visibleSlides) {
      visibleSlides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.currentSlide);
      });
    }

    goToNextSlide() {
      const slides = this.visibleSlides;
      if (slides.length <= 1) return;
      this.currentSlide = (this.currentSlide + 1) % slides.length;
      this.renderActiveSlide();
    }

    goToPreviousSlide() {
      const slides = this.visibleSlides;
      if (slides.length <= 1) return;
      this.currentSlide = (this.currentSlide + slides.length - 1) % slides.length;
      this.renderActiveSlide();
    }

    startTimer(visibleSlides = this.visibleSlides) {
      this.stopTimer();
      if (visibleSlides.length <= 1) return;
      this.intervalId = window.setInterval(() => this.goToNextSlide(), this.timerLength);
    }

    stopTimer() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    updateStickyOffset() {
      if (!this.stickyEnabled) return;
      const headerElem = this.headerElem || document.querySelector('[data-header]') || document.querySelector('header');
      const headerHidden = headerElem ? headerElem.classList.contains('-translate-y-full') : false;
      const offset = headerElem && !headerHidden ? headerElem.offsetHeight : 0;
      this.classList.toggle('promo-strip--hidden', headerHidden);
      this.style.setProperty('--promo-strip-sticky-top', `${offset}px`);
    }
  }

  if (!window.customElements.get('promo-strip-section')) {
    window.customElements.define('promo-strip-section', PromoStripSection);
  }

  } catch(e) { console.error(e); }
})();
})();
